import type { Dispatch } from 'redux'
import branditRails from '../../../../api/brandit_rails'
import {
  clearPortalPagesErrorsAction,
  setPortalPagesErrorsAction,
  setPortalPageDataAction,
  setPortalPagesStatusAction
} from './portalPages.actions'
import type { PortalPage } from './portalPages.types'

/**
 * Fetch a single portal page by ID.
 * GET /pages/:pageId
 *
 * Response envelope from render_success: { status, message, success, data: PortalPage }
 */
export const fetchPortalPage = (pageId: number) => async (dispatch: Dispatch) => {
  try {
    dispatch(setPortalPagesStatusAction('loading'))
    dispatch(clearPortalPagesErrorsAction())

    const { data: response } = await branditRails.get<{ data: PortalPage }>(`/pages/${pageId}`)

    const fetchedPage = response.data

    dispatch(setPortalPageDataAction({ pageId, page: fetchedPage }))
    dispatch(setPortalPagesStatusAction('succeeded'))
  } catch (err: any) {
    dispatch(setPortalPagesStatusAction('failed'))
    dispatch(
      setPortalPagesErrorsAction({
        action: 'fetchPortalPage',
        message: err.message || err.response?.data?.message || 'Failed to fetch portal page'
      })
    )
  }
}
